import { get } from "lodash";

// Generic function to set data and pagination details
const setDataAndPagination = (state, key, payload) => {
  if (payload) {
    const data = get(payload, "data", []);
    state[key].paginationDetails.currentPage = get(payload, "pageNumber", 1);
    state[key].paginationDetails.totalPages = get(payload, "totalPages", 0);
    state[key].paginationDetails.pageSize = get(payload, "size", 10);
    state[key].paginationDetails.totalData = get(payload, "totalData", 0);
    state[key].data = data;
  } else {
    state[key].data = [];
    state[key].paginationDetails = state.defaultPaginationDetails;
  }
};

const setAPIAccess = (state, payload) => {
  setDataAndPagination(state, "apiAccess", payload);
};

export default { setAPIAccess };
